var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFemale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 20,
    width: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.667 16.583v-1.5h-1.5v-.666h1.5v-2.355q-1.479-.187-2.49-1.25-1.01-1.062-1.01-2.52 0-1.625 1.114-2.75Q8.396 4.417 10 4.417q1.604 0 2.719 1.125 1.114 1.125 1.114 2.75 0 1.458-1.01 2.52-1.011 1.063-2.49 1.25v2.355h1.5v.666h-1.5v1.5ZM10 11.417q1.312 0 2.24-.927.927-.928.927-2.24 0-1.312-.927-2.24-.928-.927-2.24-.927-1.312 0-2.24.927-.927.928-.927 2.24 0 1.312.927 2.24.928.927 2.24.927Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemale);
export default __webpack_public_path__ + "static/media/female.83dae5edc02c604ae3e07741867e6419.svg";
export { ForwardRef as ReactComponent };